export const selectNavigation = (state) => state.navigation;
export const selectInvoicingSteps = (state) => state.navigation.invoicing;
export const selectAppUser = (state) => state.navigation.appUser;
export const selectButtonState = (state) => state.navigation.signalButtonState;
export const selectAntennaTag = (state) => state.navigation.signalAntennaTag;
export const selectTagInput = (state) => state.navigation.signalTagInput;
export const selectTablesFilters = (state) => state.navigation.tableFilters;
export const selectTerminal = (state) => state.navigation.terminal;
